import { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, Navigate } from 'react-router-dom';
import { changeAgentAccessRights } from "../../redux/modules/agents";
import Layout from "../layout"
import Select from 'react-select';
import PopupMsg from "../common/popup-msg"
import { closeErrorMsg } from "../../redux/modules/agents";


const ChangeAccess = () => {
  const location = useLocation();
  const [selectedOption, setSelectedOption] = useState(location.state.group);
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const agents = useSelector(state => state.agents);

  const handleSubmit = (e) => {
    e.preventDefault();    

     dispatch(
      changeAgentAccessRights({
        cmd: 'agents-access',
        id: location.state.id,
        group: selectedOption.value,
        _debug_token: auth.token
      })
     )
  }

  if(agents.action) return <Navigate to='/agents-list' replace />

  return (    
    <Layout>
      <div className="action-block action-block_access">
        <div className="action-block__wrap">
          <div className="action-block__title">Изменение прав доступа</div>      
          <div className="action-block__text">Пользователь {location.state.fio}</div>      
          <div className="action-block__select">
            <div className="action-block__label">Права доступа</div>            
            <Select
              className="select"
              classNamePrefix="select"
              placeholder={'Выбрать...'}              
              components={{
                DropdownIndicator: () => null,
                IndicatorSeparator: () => null,
              }} 
              defaultValue={selectedOption}
              onChange={setSelectedOption}
              options={[
                { value: 'brocker', label: 'Брокер' },
                { value: 'lead', label: 'Администратор' }
              ]}
            />  
          </div>      
          <div className="action-block__buttons">
            <button type={'submit'} className="btn" onClick={handleSubmit}>Сохранить</button>
            <Link to="/agents-list" className="btn btn_empty">Отменить</Link>
          </div>
        </div>
      </div>
      {agents.error && <PopupMsg message={agents.error} close={closeErrorMsg()} />}
    </Layout>
  )
}

export default ChangeAccess